import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 flex flex-col">
      {/* Contest Banner */}

      {/* Main Content */}
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-4 py-8 lg:py-12">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Privacy Policy – TAMILSANDHAI RETAILERS
            </h1>
            <p className="text-sm text-gray-500">
              Last updated: 2025
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8 space-y-8">
            {/* Intro */}
            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
                tamilsandhai Privacy Policy (Original Statement)
              </h2>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                This Privacy Policy describes how your personal information is
                collected, used, and shared when you visit or make a purchase
                from <span className="font-medium">www.tamilsandhai.in</span> (the{" "}
                <span className="italic">“Site”</span>).
              </p>
            </section>

            {/* Personal Information We Collect */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Personal Information We Collect
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-3">
                When you visit the Site, we automatically collect certain
                information about your device, including information about your
                web browser, IP address, time zone, and some of the cookies that
                are installed on your device. Additionally, as you browse the
                Site, we collect information about the individual web pages or
                products that you view, what websites or search terms referred
                you to the Site, and information about how you interact with the
                Site. We refer to this automatically-collected information as{" "}
                <span className="font-medium">“Device Information.”</span>
              </p>

              <p className="text-sm md:text-base text-gray-700 mb-2">
                We collect Device Information using the following technologies:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>
                  <span className="font-medium">Cookies:</span> Data files
                  placed on your device, often including a unique anonymous
                  identifier.
                </li>
                <li>
                  <span className="font-medium">Log files:</span> Track actions
                  on the Site, including IP address, browser type, ISP,
                  referring/exit pages, and timestamps.
                </li>
                <li>
                  <span className="font-medium">Web beacons, tags, pixels:</span>{" "}
                  Electronic files recording browsing behaviour.
                </li>
              </ul>

              <p className="text-sm md:text-base text-gray-700 mt-4 mb-2">
                Additionally, when you make or attempt to make a purchase
                through the Site, we collect Order Information such as:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Name</li>
                <li>Billing/Shipping address</li>
                <li>Payment information (including card numbers)</li>
                <li>Email address</li>
                <li>Phone number</li>
              </ul>

              <p className="text-sm md:text-base text-gray-700 mt-4">
                “Personal Information” in this Privacy Policy refers to both
                Device Information and Order Information.
              </p>
            </section>

            {/* How We Use Your Personal Information */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                How We Use Your Personal Information
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                Order Information is used to fulfill orders, process payments,
                arrange shipping, and provide order confirmations. We also:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-4">
                <li>Communicate with customers</li>
                <li>Screen orders for potential fraud</li>
                <li>Provide product or service-related information</li>
              </ul>
              <p className="text-sm md:text-base text-gray-700">
                Device Information helps improve and optimize the Site and
                supports fraud prevention.
              </p>
            </section>

            {/* Sharing Your Personal Information */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Sharing Your Personal Information
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We may share Personal Information with third parties, including:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-4">
                <li>Shopify – store backend</li>
                <li>Google Analytics – usage tracking</li>
              </ul>
              <p className="text-sm md:text-base text-gray-700">
                We may also share information to comply with applicable laws,
                respond to subpoenas, or protect our business rights.
              </p>
            </section>

            {/* Behavioural Advertising */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Behavioural Advertising
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We may use your information to deliver targeted advertisements
                through platforms such as:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Facebook</li>
                <li>Google</li>
                <li>Bing</li>
              </ul>
            </section>

            {/* Do Not Track */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Do Not Track
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                We do not alter our data collection and usage practices when we
                see a Do Not Track signal from your browser.
              </p>
            </section>

            {/* EU Rights */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Your Rights (EU Residents)
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                If you are a European resident, you have the right to request
                access to the personal data we hold about you and to ask that
                your personal data be corrected, updated, or deleted.
              </p>
            </section>

            {/* Data Retention */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Data Retention
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                When you place an order through the Site, we will maintain your
                Order Information for our records unless and until you ask us to
                delete this information.
              </p>
            </section>

            {/* Changes */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Changes
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                We may update this Privacy Policy from time to time to reflect
                changes to our practices or for operational, legal, or
                regulatory reasons.
              </p>
            </section>

            {/* Contact (from original block) */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Contact
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-1">
                For more information about our privacy practices or if you have
                questions, please contact us:
              </p>
              <ul className="text-sm md:text-base text-gray-700 space-y-1">
                <li>
                  Email:{" "}
                  <a
                    href="mailto:info@tamilsandhai.in"
                    className="text-blue-600 hover:underline"
                  >
                    info@tamilsandhai.in
                  </a>
                </li>
                <li>
                  Address: No. H25, Thally Road, Old ASTC Hudco, Hosur,
                  Krishnagiri (Dt), PIN: 635109.
                </li>
              </ul>
            </section>

            {/* Extended Information We Collect */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Information We Collect
              </h2>

              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                Personal Information
              </h3>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We may collect the following details when you interact with our
                Website or make a purchase:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-4">
                <li>Name</li>
                <li>Email Address</li>
                <li>Phone Number</li>
                <li>Billing/Shipping Address</li>
                <li>Payment-related information (via secure third-party gateways)</li>
              </ul>

              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                Automatically Collected Information
              </h3>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                When you visit our Website, we may automatically collect:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-4">
                <li>IP address</li>
                <li>Device information</li>
                <li>Browser type</li>
                <li>Pages viewed and time spent</li>
                <li>Cookies and tracking data</li>
              </ul>

              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                Communication Data
              </h3>
              <p className="text-sm md:text-base text-gray-700">
                Information provided through customer support, contact forms, or
                email may be stored for service improvement.
              </p>
            </section>

            {/* How We Use Your Information (Extended) */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                How We Use Your Information
              </h2>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-3">
                <li>Order processing and fulfilment</li>
                <li>Customer support</li>
                <li>Order updates and notifications</li>
                <li>Improving user experience</li>
                <li>Fraud prevention</li>
                <li>Legal compliance</li>
              </ul>
              <p className="text-sm md:text-base text-gray-700">
                We do <span className="font-semibold">NOT</span> sell or rent
                your personal information to any third party.
              </p>
            </section>

            {/* Cookies & Tracking */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Cookies &amp; Tracking Technologies
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We use cookies and similar technologies to:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Enhance browsing experience</li>
                <li>Remember preferences</li>
                <li>Analyze site traffic</li>
              </ul>
            </section>

            {/* Sharing of Information */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Sharing of Information
              </h2>
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                Service Providers
              </h3>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We may share information with:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700 mb-4">
                <li>Payment gateways</li>
                <li>Courier partners</li>
                <li>Analytics and IT services</li>
              </ul>

              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">
                Legal Compliance
              </h3>
              <p className="text-sm md:text-base text-gray-700">
                We may disclose information to:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Law enforcement agencies</li>
                <li>Government authorities</li>
                <li>Court orders and legal processes</li>
              </ul>
            </section>

            {/* Data Security */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Data Security
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                We implement reasonable measures to protect your information
                from:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Unauthorized access</li>
                <li>Data misuse or alteration</li>
                <li>Loss or destruction</li>
              </ul>
              <p className="text-sm md:text-base text-gray-700 mt-2">
                Data access is controlled and limited to authorized personnel
                only.
              </p>
            </section>

            {/* Your Rights */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Your Rights
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm md:text-base text-gray-700">
                <li>Access your personal data</li>
                <li>Request corrections to your data</li>
                <li>Request deletion of your data, subject to legal obligations</li>
              </ul>
            </section>

            {/* Third-Party Links */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Third-Party Links
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                Our Website may contain links to external sites. These sites may
                have different privacy policies, and we encourage you to review
                their policies before providing any personal information.
              </p>
            </section>

            {/* Children's Privacy */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Children&apos;s Privacy
              </h2>
              <p className="text-sm md:text-base text-gray-700">
                We do not knowingly collect personal data from individuals below
                18 years of age. If you believe that such data has been
                collected, please contact us so that we can remove it.
              </p>
            </section>

            {/* Contact Information (Extended) */}
            <section>
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">
                Contact Information
              </h2>
              <div className="space-y-1 text-sm md:text-base text-gray-700">
                <p>📍 TAMILSANDHAI RETAILERS</p>
                <p>H25, OLD ASTC HUDCO,</p>
                <p>THALLY ROAD, HOSUR,</p>
                <p>TAMIL NADU – 635109</p>
                <p>
                  📧{" "}
                  <a
                    href="mailto:info@tamilsandhai.in"
                    className="text-blue-600 hover:underline"
                  >
                    info@tamilsandhai.in
                  </a>
                </p>
                <p>
                  🌐{" "}
                  <a
                    href="https://tamilsandhai.in/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    https://tamilsandhai.in/
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
